//* Libraries imports
import z from "zod";

//* Schemas imports
import { nameSchema } from "../../name";
import { dateFormat } from "../../date";

export const paginatedEssay = z.object({
  id: z.number(),
  title: nameSchema,
  statement: z.string(),
  correctionStatus: z.literal("PENDENTE").or(z.literal("CORRIGIDA")),
  textoRedacaoId: z.number().optional().nullable(),
});
export type PaginatedEssay = z.infer<typeof paginatedEssay>;

export const annotationSchema = z.object({
  id: z.number(),
  comentario: z.string(),
  correctorName: z.string(),
});

export const criterioZeroSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const correctionSchema = z.object({
  id: z.number(),
  image: z.string(),
  annotations: z.array(annotationSchema).optional(),
  criteriosZero: z.array(criterioZeroSchema).optional(),
});

export const fullEssay = z.object({
  id: z.number(),
  name: nameSchema,
  enunciado: z.string(),
  titleCandidate: z.string(),
  hasCorrections: z.boolean().optional(),
  correctionStatus: z.enum(["NAO_ESCANEADO", "PENDENTE", "CORRIGIDA"]),
  corrections: z.array(correctionSchema),
  file: z.string().nullish(),
  submittedAt: dateFormat,
  updatedAt: dateFormat,
});

export const templateEssay = z.object({
  essayModel: z.object({
    id: z.number(),
    name: z.string(),
    enunciado: z.string(),
    enunciadoContent: z.string(),
    numberLines: z.number(),
  }),
});

export type Annotation = z.infer<typeof annotationSchema>;
export type CriterioZero = z.infer<typeof criterioZeroSchema>;
export type Correction = z.infer<typeof correctionSchema>;
export type FullEssay = z.infer<typeof fullEssay>;
export type TemplateEssay = z.infer<typeof templateEssay>;

